import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import SamplesTab from '../../../../../../pages/experiments/sampleManagement/SamplesTab';
import { sampleSetMetadataValuesQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples'
)({
  staticData: { ddViewName: 'experiments-samples-tab' },
  loader: ({ context, params }) => {
    // Prefetch metadata values for the samples tab filter bar.
    context.queryClient.prefetchQuery(
      sampleSetMetadataValuesQueryOptions(
        params.sampleSetId,
        context.auth.hasPermission
      )
    );
  },
  component: SamplesRouteComponent,
});

function SamplesRouteComponent() {
  const { sampleSet } = useSampleSet();

  if (!sampleSet) {
    return null;
  }

  return <SamplesTab selectedSampleSet={sampleSet} />;
}
